import { render, staticRenderFns } from "./GAccountEmailAndPw.vue?vue&type=template&id=2f6f9d32&scoped=true&"
import script from "./GAccountEmailAndPw.vue?vue&type=script&lang=ts&"
export * from "./GAccountEmailAndPw.vue?vue&type=script&lang=ts&"
import style0 from "./GAccountEmailAndPw.vue?vue&type=style&index=0&id=2f6f9d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f9d32",
  null
  
)

export default component.exports